import React from "react";

export function CompletionStepsIndicator({ steps, currentStep }) {
  return (
    <div className="business-completion-steps business-completion-steps-inline">
      {steps.map((step, index) => (
        <div
          key={step.id}
          className={`step-indicator ${currentStep >= step.id ? "active" : ""} ${currentStep === step.id ? "current" : ""}`}
        >
          <div className="step-number">{step.id}</div>
          <span className="step-title">{step.short}</span>
          {index < steps.length - 1 && <div className="step-connector" />}
        </div>
      ))}
    </div>
  );
}
